module.exports = __webpack_public_path__ + "img/meishan.fdd3891b.jpg";